/**
 * 与 ssr-web-index Alternate/Social 一致：resolvedUrl 已是 /accounts/... 全路径，勿再拼 basePath。
 * @param {string} locale
 * @param {string} [resolvedUrl] — 如 /accounts/register
 * @param {string} [basePath] — resolvedUrl 为空时的兜底，默认 accounts
 */
export function buildSeoPagePath(locale, resolvedUrl = "", basePath = "accounts") {
  const loc = locale || "en";
  const path = String(resolvedUrl || "").trim();

  if (!path || path === "/") {
    return `/${loc}/${basePath}`.replace(/\/+/g, "/");
  }

  const suffix = path.startsWith("/") ? path : `/${path}`;
  if (suffix.startsWith("/accounts")) {
    return `/${loc}${suffix}`.replace(/\/+/g, "/");
  }

  return `/${loc}/${basePath}${suffix}`.replace(/\/+/g, "/");
}
